module.exports = __webpack_public_path__ + "media/Components/Logos/icon-text-right-41391f0fc20f7d0819cc4c238a1e1552.svg";